import { render, staticRenderFns } from "./CreateStudioSocials.vue?vue&type=template&id=e5984208&scoped=true"
import script from "./CreateStudioSocials.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateStudioSocials.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateStudioSocials.vue?vue&type=style&index=0&id=e5984208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5984208",
  null
  
)

export default component.exports